import { Theme } from "@mui/material/styles";
import rgba from "assets/theme/functions/rgba";

interface Styles {
  [key: string]: any;
}

export const styles = (theme: Theme): Styles => ({
  headerContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    height: "410px",
    padding: theme.spacing.spacing10,
  },
  headerContainer_SHORT: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    padding: theme.spacing.spacing10,
  },
  headerContainerBG: {
    background: (theme.palette.background as any).primary,
  },
  logoRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: theme.width.full,
  },
  brandLogo: {
    alignSelf: "flex-start",
    height: 36,
    width: theme.width.width62_5,
  },
  title: {
    fontSize: theme.typography.size.md,
    fontWeight: theme.typography.fontWeightMedium,
    whiteSpace: "pre-line",
    textAlign: "center",
  },
  titleWithMargin: {
    marginTop: theme.spacing.spacing20,
  },
  noPaddingTop: {
    paddingTop: 0,
  },
  descriptionWithMargin: {
    marginTop: theme.spacing.spacing10,
  },
  largeTitle: {
    fontSize: theme.typography.size.size13,
    fontWeight: theme.typography.fontWeightMedium,
    whiteSpace: "pre-line",
    textAlign: "center",
  },
  descriptionSection: {
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.size.xs,
    width: theme.width.full,
  },
  descriptionBoxText: {
    alignSelf: "flex-start",
  },
  descriptionBoxContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: theme.spacing.spacing25,
    background: rgba(theme.palette.white.main, 0.5),
    borderRadius: theme.borders.borderRadius.lg,
    padding: `${theme.spacing.spacing8} ${theme.spacing.spacing10}`,
  },
  description: {
    whiteSpace: "pre-line",
  },
  loadingCircle: {
    width: theme.width.width8,
    height: 16,
    margin: `0 ${theme.spacing.spacing5}`,
    borderRadius: 100,
  },
  languageWrapper: {
    display: "flex",
    alignItems: "center",
  },
  hmoSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 60,
    gap: theme.spacing.spacing5,
  },
  hmoLogo: {
    height: 50,
    width: 50,
    objectFit: "contain",
  },
  hmoName: {
    fontSize: theme.typography.size.md,
    fontWeight: theme.typography.fontWeightMedium,
    textAlign: "center",
    color: (theme.palette.text as any).main,
  },
  //remove after testing
  versionText: {
    position: "absolute",
    top: theme.spacing.spacing5,
    right: theme.spacing.spacing5,
    fontSize: theme.typography.size.xxs,
    fontWeight: theme.typography.fontWeightRegular,
    color: (theme.palette.text as any).main,
    zIndex: 1,
  },
});
